import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=0c1c4568&scoped=true&"
import script from "./remark.vue?vue&type=script&lang=js&"
export * from "./remark.vue?vue&type=script&lang=js&"
import style0 from "./remark.vue?vue&type=style&index=0&id=0c1c4568&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1c4568",
  null
  
)

export default component.exports